<template>
  <div class="view contentBody">
    <div class="content">
      <div class="content-tab-box">
        <span :class="meaulistTab.firstTab==item?'content-tab-box-active':''" @click="tabCurrentFn(item)"
              v-for="(item,index) in meaulistTab.tab" :key="item">{{index}}</span>
      </div>
      <div v-for="item in meaulistTab.tab" :key="item">
        <component v-bind:is="item" v-if="meaulistTab.firstTab==item"></component>
      </div>
      <!--<el-tab-pane label="员工数据" name="MaterialEmployee">-->
      <!--<MaterialEmployee></MaterialEmployee>-->
      <!--</el-tab-pane>-->
    </div>
  </div>
</template>
<script>
  import MaterialArticle from "./MaterialArticle.vue";
  import MaterialData from "./MaterialData.vue";
  import MaterialEmployee from "./MaterialEmployee.vue";
  let tabBox = {
    '文章列表': {property: 'MaterialArticle'}
  }
  export default {
    name: "material",
    components: {
      MaterialArticle,
      MaterialData,
      MaterialEmployee
    },
    data() {
      return {
        meaulistTab: this.meaulist.meaulistGet(this, tabBox),
        activeName:''
      };
    },
    created() {
      this.inittab();
    },
    methods: {
      inittab() {
        this.activeName =
            this.$route.query.tab !== undefined
                ? this.$route.query.tab
                : "MaterialArticle";
      },
      tabCurrentFn(index) {
        this.meaulistTab.firstTab = index
      }
    }
  };
</script>
